import React, { useState } from 'react';
import { 
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaExpand,
  FaCompress
} from 'react-icons/fa';

const SimpleGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const galleryImages = [
    "https://images.tv9hindi.com/wp-content/uploads/2025/02/cancer-pic.jpg",
    "https://www.cancertherapyadvisor.com/wp-content/uploads/sites/12/2023/01/patient-with-cancer_G_939771318.jpg",
    "https://taelimalhurufalearabia.com/wp-content/uploads/2025/01/a.webp",
    "https://resize.indiatv.in/resize/newbucket/1200_-/2025/07/back-pain-kidney-cancer-09-07-2025-1752040936.jpg",
    "https://d3uigcfkiiww0g.cloudfront.net/wordpress/blog/pics-en/uploads/ColorectalCancer.png",
    "https://urologyaustin.com/wp-content/uploads/2018/07/iStock-531985630.jpg",
    "https://tse1.explicit.bing.net/th/id/OIP.NtnlJ4nlapB6dTlJKAmqKgHaEj?w=650&h=400&rs=1&pid=ImgDetMain&o=7&rm=3",
    "https://media.sciencephoto.com/image/f0234974/800wm/F0234974-Illustration_of_a_human_cancer_cell.jpg",
    "https://content.jdmagicbox.com/comp/daltanganj/j2/9999p6562.6562.231025034443.t7j2/catalogue/urologist-dr-shailendra-m-shukla-hamidganj-daltanganj-urologist-doctors-k1t5jl8847.jpg",
    "https://i.ytimg.com/vi/q9LdAQTUM2s/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAhATkhewhZjuekL6QhdeEsjAsfTQ",
    "https://images.jdmagicbox.com/comp/palamu/d1/9999p6562.6562.230706172833.b3d1/catalogue/dr-shailendra-mohan-shukla-hamidganj-daltanganj-urologist-doctors-i2d196bw5t.jpg",
    "https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
  ];

  const handleImageClick = (url, index) => {
    setSelectedImage(url);
    setCurrentIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
    setIsFullscreen(false);
    document.body.style.overflow = 'unset';
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
  };

  const handlePrev = () => {
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
  };

  const handleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  // Handle keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImage) {
        if (e.key === 'Escape') handleCloseModal();
        if (e.key === 'ArrowRight') handleNext();
        if (e.key === 'ArrowLeft') handlePrev();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex]);

  return (
    <section className="py-8 md:py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Gallery Grid - Just Images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 md:gap-3">
          {galleryImages.map((url, index) => (
            <div 
              key={index}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              onClick={() => handleImageClick(url, index)}
            >
              <div className="aspect-square overflow-hidden bg-gray-200">
                <img
                  src={url}
                  alt={`Gallery image ${index + 1}`}
                  className="w-full h-full object-cover transform transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
              </div>
              
              {/* View icon on hover */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-8 h-8 bg-white/90 rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform">
                  <svg className="w-4 h-4 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fullscreen Image Modal */}
      {selectedImage && (
        <div className={`fixed inset-0 z-50 ${isFullscreen ? 'bg-black' : 'bg-black/95'}`}>
          {/* Close button */}
          <button
            onClick={handleCloseModal}
            className="absolute top-4 right-4 z-20 w-10 h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300"
          >
            <FaTimes className="text-lg" />
          </button>

          {/* Fullscreen toggle button */}
          <button
            onClick={handleFullscreen}
            className="absolute top-4 left-4 z-20 w-10 h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300"
          >
            {isFullscreen ? <FaCompress className="text-sm" /> : <FaExpand className="text-sm" />}
          </button>

          {/* Navigation buttons */}
          <button
            onClick={handlePrev}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300"
          >
            <FaChevronLeft />
          </button>
          
          <button
            onClick={handleNext}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300"
          >
            <FaChevronRight />
          </button>

          {/* Main image */}
          <div className="h-full w-full flex items-center justify-center p-4">
            <img
              src={selectedImage}
              alt="Full view"
              className="max-w-full max-h-full object-contain"
            />
          </div>

          {/* Image counter (only in non-fullscreen) */}
          {!isFullscreen && (
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/50 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm">
              {currentIndex + 1} / {galleryImages.length}
            </div>
          )}

          {/* Thumbnail strip (only in non-fullscreen) */}
          {!isFullscreen && (
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
              <div className="flex justify-center space-x-2 overflow-x-auto py-2">
                {galleryImages.map((url, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setSelectedImage(url);
                      setCurrentIndex(index);
                    }}
                    className={`flex-shrink-0 w-16 h-16 rounded overflow-hidden border-2 transition-all duration-300 ${
                      currentIndex === index
                        ? 'border-white scale-110'
                        : 'border-transparent opacity-50 hover:opacity-100'
                    }`}
                  >
                    <img
                      src={url}
                      alt={`Thumbnail ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default SimpleGallery;